import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/pt-br";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

const Practices = () => {
  const [practices, setPractices] = useState([]);
  const [category, setCategory] = useState("");

  // const category = new URLSearchParams(useLocation().search).get("category");

  useEffect(() => {
    async function exibir() {
      let payload;

      if (category.length > 0) {
        payload = apiGet(`/practices?category=${category}`);
      } else {
        payload = apiGet("/practices");
      }

      setPractices((await payload).data.data);
    }
    exibir();
  }, [category]);

  const onChangeHandler = async (e) => {
    const payload = apiGet("/practices/api/pesquisar?termo=" + e.target.value);
    setPractices((await payload).data.data);
  };

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Práticas Pedagógicas</h2>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
              <InputLabel id="select-label">Categoria</InputLabel>
              <Select
                labelId="select-label"
                id="simple-select"
                value={category}
                label="Categoria"
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >
                <MenuItem value="">
                  <em>Todas</em>
                </MenuItem>
                <MenuItem value={"Cultura"}>Cultura</MenuItem>
                <MenuItem value={"Inclusão"}>Inclusão</MenuItem>
                <MenuItem value={"Intercâmbios"}>Intercâmbios</MenuItem>
                <MenuItem value={"Sustentabilidade"}>Sustentabilidade</MenuItem>
                <MenuItem value={"Tecnologia e Inovação"}>
                  Tecnologia e Inovação
                </MenuItem>
                <MenuItem value={"Visita técnica"}>Visita técnica</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <div className="search">
              <input
                type="text"
                onChange={(e) => onChangeHandler(e)}
                placeholder="Pesquise aqui..."
              />
            </div>
          </div>
        </div>

        {practices && practices.length ? (
          practices.map((practice) => {
            return (
              <div className="row mx-5 posts" key={practice.practice_id}>
                <div className="card mb-3">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card-body">
                        <h5 className="card-title">{practice.title}</h5>
                        <p className="card-text m-0">
                          <small className="text-muted">
                            {practice.place} -{" "}
                            {moment(practice.when).format("LL")} [
                            {practice.subject}]
                          </small>
                        </p>
                        <p className="card-text m-0">
                          <div className="artigo-link">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: practice.abstract,
                              }}
                            ></span>
                            <div>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={practice.link}
                              >
                                Leia mais.
                              </a>
                            </div>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="row mx-5 posts">
            <div className="card mb-3">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card-body">
                    <h5 className="card-title">
                      Nenhuma prática para esta pesquisa.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default Practices;
